<template>
  <div class="contract-item-wrap">
    <div class="contract-content">
      <label :style="width?`width:${width}px; flex: 0 0 ${width}px;`:''">
        {{ label }}
        <span class="required-span" v-if="isRequired"/>
      </label>
      <div class="contract-item-input-wrap" :class="class">
        <slot />
      </div>
    </div>
    <div class="error-message-wrap" :style="width?`margin-left:${width+10}px;`:''">
      <div
          v-for="(item, index) of errorIds" :id="item" class="error-message"
      />
    </div>
  </div>
</template>
<script>

import {RouterEnum} from "@/enums/router.enums";

import {
  logging,
} from "@/utils/utils";

export default {
  name: 'ContractItemWrap',
  props: {
    label: {
      type: String,
      required: false,
    },
    class: {
      type: String,
      required: false,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    errorIds: {
      type: Array,
    },
    width: {
      type: String,
    }
  },
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/contract-detail';
</style>